/** @format */

export function HandleFacets() {
	return ['master_category', 'category', 'laboratory', 'promotion_tag', 'cenabast'];
}
